<template>
  <b-row class="table-statistic-wrapper mx-5 mt-5">
    <b-col
      cols="auto"
      class="table-statistic-col"
      v-for="(stat, sIndex) in statistics"
      :key="`statistic-${sIndex}`"
    >
      <div class="table-statistic-card pr-5">
        <h6 class="font-weight-bolder">{{ stat.title }}</h6>
        <p>{{ stat.desc }}</p>
        <h1 class="font-weight-bolder" :class="stat.value_class">
          {{ stat.value || 0 }}
        </h1>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "GrowerWebTableStatistic",

  props: {
    statistics: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  mounted() {
    
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.table-statistic-wrapper {
  .table-statistic-col {
    .table-statistic-card {
      min-width: 250px;
      border-right: 1px solid #e7e9eb;
    }
  }
  .table-statistic-col:last-child {
    .table-statistic-card {
      border-right: 0px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/base/component/table-statistic.vue